import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useEffect, useRef, useState } from "react";

export const ServiceTile = ({ service, className = "" }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setInView(true);
        });
      },
      { threshold: 0.4, rootMargin: "0px 0px -10% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Link
      ref={ref}
      to={`/services/${service.slug}`}
      className={`service-tile group relative block overflow-hidden border border-neutral-700 ${inView ? "in-view" : ""} ${className}`}
      data-testid={`service-tile-${service.slug}`}
    >
      {/* Image */}
      <div className="absolute inset-0">
        <img
          src={service.image_url}
          alt={service.title}
          loading="lazy"
          decoding="async"
          className="service-tile-image w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
      </div>

      {/* Arrow chip — top-right, only on hover */}
      <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
        <ArrowUpRight className="w-5 h-5 text-ink" />
      </div>

      {/* Content — centred at the bottom */}
      <div className="relative h-full flex flex-col items-center justify-end text-center p-6">
        <h3 className="font-heading text-xl md:text-2xl font-semibold text-white mb-2 leading-tight">
          {service.title}
        </h3>
        <p className="text-gray-300 text-sm leading-snug max-w-[28ch] mx-auto">
          {service.description}
        </p>
      </div>
    </Link>
  );
};

export default ServiceTile;
